/**
 * Whether the visitor asked for less motion (`prefers-reduced-motion: reduce`).
 *
 * The stylesheet stops every transition of the frontend through the duration tokens
 * (tokens.less); a script which moves something by itself asks here: the autoplay and the
 * slide animation of a slider, the slide show which the lightbox starts on its own, a video
 * which plays as soon as its slide opens. What the visitor starts - the play button of the
 * slide show, the play button of a video - still runs.
 *
 * @param {Window} [win]
 * @returns {boolean}
 */
export function prefersReducedMotion(win = typeof window !== 'undefined' ? window : undefined) {
    return Boolean(win && typeof win.matchMedia === 'function' && win.matchMedia('(prefers-reduced-motion: reduce)').matches);
}
